module.exports = ".card-checks{padding-left:3vh !important;padding:1vh;margin-left:18%;margin-right:18%}\n"